import React from 'react';

import '../scss/Elements/_tables.scss';
import { Helmet } from 'react-helmet';
import { useTranslationHook } from '../hooks/UseTranslationHook';
import { VisitsTableAxios } from '../components/Tables/VisitsTable';

function Visits() {
  const { titleVisitsString } = useTranslationHook();

  return (
    <div className='table-module-container'>
      <Helmet>
        <title>{titleVisitsString}</title>
      </Helmet>
      <div className='datatable'>
        <VisitsTableAxios />
      </div>
    </div>
  );
}

export default Visits;
